import React from "react";
import {
  GiftIcon,
  XIcon,
  ListIcon,
  EyeSlashIcon,
  CalendarIcon,
  CheckCircleIcon,
} from "@phosphor-icons/react";
import "./SurpriseEventHelpModal.css";

interface SurpriseEventHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SurpriseEventHelpModal: React.FC<SurpriseEventHelpModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      onClose();
    }
  };

  return (
    <div className="help-modal-overlay" onClick={handleOverlayClick}>
      <div
        className="help-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="help-modal-title"
        onKeyDown={handleKeyDown}
        tabIndex={-1}
      >
        <div className="help-modal-header">
          <h3 id="help-modal-title">Come funziona un evento a sorpresa</h3>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Chiudi finestra di aiuto"
          >
            <XIcon size={20} />
          </button>
        </div>
        <div className="help-modal-content">
          <div className="help-intro">
            <div className="help-intro-circle-icon">
              <GiftIcon size={32} weight="fill" className="help-icon" />
            </div>
            <p>
              Gli eventi a sorpresa mantengono segrete le prenotazioni per
              preservare l'elemento sorpresa!
            </p>
          </div>

          <div className="help-steps">
            <div className="help-step">
              <div className="step-icon">
                <ListIcon size={20} weight="fill" />
              </div>
              <div className="step-content">
                <h4>1. Prepara la tua lista</h4>
                <p>
                  Crea la tua lista regalo in privato, nessuno la vedrà finché
                  non la pubblichi
                </p>
              </div>
            </div>

            <div className="help-step">
              <div className="step-icon">
                <CheckCircleIcon size={20} weight="fill" />
              </div>
              <div className="step-content">
                <h4>2. Pubblica quando sei pronto</h4>
                <p>Rendi la lista visibile agli altri membri del gruppo</p>
              </div>
            </div>

            <div className="help-step">
              <div className="step-icon">
                <EyeSlashIcon size={20} weight="fill" />
              </div>
              <div className="step-content">
                <h4>3. Le prenotazioni rimangono segrete</h4>
                <p>
                  Non vedrai chi prenota i tuoi regali e gli altri non vedranno
                  le tue prenotazioni
                </p>
              </div>
            </div>

            <div className="help-step">
              <div className="step-icon">
                <CalendarIcon size={20} weight="fill" />
              </div>
              <div className="step-content">
                <h4>4. Rivelazione dopo l'evento</h4>
                <p>
                  Tutte le prenotazioni diventano visibili solo dopo la data
                  dell'evento
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurpriseEventHelpModal;
